import { Component } from '@angular/core';
import { DrawingsHolderService } from '../../drawings-holder.service';
import { IColorChangeable } from '../../Interfaces';
import { Text } from '../../object3D';

declare let THREE: any;

@Component({
  selector: 'app-change-object-color',
  templateUrl: './change-object-color.component.html',
  styleUrls: ['./change-object-color.component.scss']
})
export class ChangeObjectColorComponent {
  isActive = false;
  private selectedObject: IColorChangeable[];
  color;

  constructor(private drawingsHolderService: DrawingsHolderService) {
    drawingsHolderService.onSelect.subscribe(obj => {
      if (obj) {
        this.isActive = obj[0] && !(obj[0] instanceof Text);
        this.selectedObject = obj as IColorChangeable[];
      }
    });
  }

  colorChange(hex: string) {
    const color = new THREE.Color(hex);
    this.selectedObject.forEach(obj => {
      obj.setColor(color);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/change-object-color/change-object-color.component.ts